import GTM from '../../../gtm/GTM';
import GTMOverviewMapHousePreviewModel from '../../../gtm/models/GTMOverviewMapHousePreviewModel';
import GTMOverviewMapSearchAreaModel from '../../../gtm/models/GTMOverviewMapSearchAreaModel';
import GTMOverviewMapShowModel from '../../../gtm/models/GTMOverviewMapShowModel';

export default class SearchMapTracking {
    public trackMapViewOpenEvent(): void {
        GTM.track(GTMOverviewMapShowModel.parseToGTMData());
    }

    public trackMapViewHousePreviewEvent(houseId: number | string): void {
        GTM.track(GTMOverviewMapHousePreviewModel.parseToGTMData({ houseId: houseId.toString() }));
    }

    public trackMapSearchAreaEvent(): void {
        GTM.track(GTMOverviewMapSearchAreaModel.parseToGTMData());
    }
}
